// extracted by mini-css-extract-plugin
export var blok_content = "index-module--blok_content--850fa";
export var btn_group = "index-module--btn_group--a884e";
export var case_card = "index-module--case_card--ebf9a";
export var case_card_container = "index-module--case_card_container--7a1c5";
export var case_cover = "index-module--case_cover--a1eb6";
export var company_info_container = "index-module--company_info_container--0c454";
export var company_logo = "index-module--company_logo--afbb3";
export var company_tag = "index-module--company_tag--be1e1";
export var company_tag_text = "index-module--company_tag_text--b2d82";
export var company_tags_container = "index-module--company_tags_container--be62a";
export var cover_container = "index-module--cover_container--51cf7";
export var cover_item = "index-module--cover_item--2040e";
export var import_case_blok = "index-module--import_case_blok--04fd1";
export var sub_title_container = "index-module--sub_title_container--618c1";
export var title_container = "index-module--title_container--85477";
export var title_desc_container = "index-module--title_desc_container--a87b0";
export var title_header = "index-module--title_header--87897";